<template>
  <div class="column is-3">
    <div class="is-border is-radius-large has-bg-white">
      <aside class="menu menu-guide">
        <div class="column">
          <strong>
            <router-link to="/">Accueil</router-link>
          </strong>
        </div>
        <div class="column has-bg-light is-radius-top-left-large is-radius-top-right-large">
          <strong>Rubriques</strong>
        </div>
        <ul>
          <li v-for="menuEntry in menuEntries" :key="menuEntry.slug" @click="changeMenu(menuEntry.slug)" class="topicMenu">
            <router-link :to="{ name: 'Topic', params: {topicId: menuEntry.slug}}" class="topicMenuLink">
              {{ menuEntry.title }}
            </router-link>
            <ul
              v-if="currentMenu === menuEntry.slug"
              class="is-size-6 has-bg-light is-padding-top-small is-padding-bottom-small"
            >
              <li v-for="children in menuEntry.children" :key="children.slug" class="pageMenu">
                <router-link :to="{ name: 'Page', params: { pageId: children.slug, topicId : menuEntry.slug }}" class="pageMenuLink">
                  {{ children.title }}
                </router-link>
              </li>
            </ul>
          </li>
          <!--
          <li v-for="topic in authorizedTopics" :key="topic.id" @click="changeMenu(topic.id)">
            <router-link :to="{ name: 'Topic', params: {topicId: topic.id}}">
              {{ topic.data.title[0].text }}
            </router-link>
            <ul
              v-if="currentMenu === topic.id"
              class="is-size-6 has-bg-light is-padding-top-small is-padding-bottom-small"
            >
              <li v-for="page in topic.pages" :key="page.id">
                <router-link :to="{ name: 'Page', params: { pageId: page.id, topicId : topic.id }}">
                  {{ page.data.title[0].text }}
                </router-link>
              </li>
            </ul>
          </li>
          -->
        </ul>
      </aside>
    </div>
  </div>
</template>

<script>
  import { mapGetters } from 'vuex'

  export default {
    name: 'MyNavbar',
    data () {
      return {
        currentMenu: null
      }
    },
    mounted () {
      this.changeMenu (this.$route.params.topicId) // sub menu ouvert a init
    },
    watch: {
      '$route' (to, from) {
        // react to route changes...
        this.changeMenu (this.$route.params.topicId) // sub menu ouvert a changement de route
      }
    },
    computed: {
      // ...mapGetters(['authorizedTopics'])
      ...mapGetters(['menuEntries']),
      topicId () {
        return this.$route.params.pageId
      },
    },
    methods: {
      changeMenu (rubricId) {
        this.currentMenu = rubricId
      }
    }
  }
</script>


<style scoped>
.menu-guide>ul>li>a.topicMenuLink.router-link-active:before{
  width:2px;
  background:#0072aa;
}
a.pageMenuLink.router-link-active {
    color: #0072aa;
}
</style>
